import { orchestrator } from 'satcheljs';
import getRemindersForWebPush from '../actions/getRemindersForWebPush';
import getRemindersService from '../services/getReminders';
import { userDate } from 'owa-datetime';
import scheduleTimerForWebPushReminder from '../services/scheduleTimerForWebPushReminder';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';

export const MIN_MINUTES_PAST = 0;
export const MAX_MINUTES_FUTURE = 1440;

export default orchestrator(getRemindersForWebPush, async () => {
    if (isFeatureEnabled('auth-scheduleTimerForReminderWebPush')) {
        try {
            const remindersResponse = await getRemindersService(
                undefined /*userIdentity*/,
                MIN_MINUTES_PAST,
                MAX_MINUTES_FUTURE
            );

            const newReminders = remindersResponse?.Reminders || [];

            const newParsedReminders = newReminders.map(reminder => ({
                ...reminder,
                parsedStartDate: userDate(reminder.StartDate),
                parsedEndDate: userDate(reminder.EndDate),
                parsedReminderTime: userDate(reminder.ReminderTime),
                userIdentity: undefined,
            }));

            scheduleTimerForWebPushReminder(newParsedReminders);
        } catch (err) {
            logUsage('getRemindersForWebPush', { Error: err.toString() });
        }
    }
});
